if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.initGalleryNavigation();

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      initGalleryNavigation() {
        if (!this.elements.viewer) return;

        const prevButtons = this.elements.viewer.querySelectorAll('button[name="previous"]');
        const nextButtons = this.elements.viewer.querySelectorAll('button[name="next"]');

        prevButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.navigateMedia('prev');
          });
        });

        nextButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.navigateMedia('next');
          });
        });

        const dots = this.querySelectorAll('.slider-counter__link--dots');
        dots.forEach((dotButton, index) => {
          dotButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
            if (mediaItems[index]) {
              this.setActiveMedia(mediaItems[index].dataset.mediaId, false);
            }
          });
        });
      }

      navigateMedia(direction) {
        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        if (!mediaItems.length) return;

        let currentIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
        if (currentIndex === -1) currentIndex = 0;

        let targetIndex = 0;
        if (direction === 'next') {
          targetIndex = currentIndex >= mediaItems.length - 1 ? 0 : currentIndex + 1;
        } else {
          targetIndex = currentIndex <= 0 ? mediaItems.length - 1 : currentIndex - 1;
        }

        const targetMedia = mediaItems[targetIndex];
        if (targetMedia) {
          this.setActiveMedia(targetMedia.dataset.mediaId, false);
        }
      }

      onSlideChanged(event) {
        if (event.detail && event.detail.currentElement) {
          this.setActiveMedia(event.detail.currentElement.dataset.mediaId, false);
        }
        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        const dots = this.querySelectorAll('.slider-counter__link--dots');
        if (dots.length) {
          const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
          const activeIndex = mediaItems.findIndex((item) => item.dataset.mediaId === mediaId);
          dots.forEach((dot, idx) => {
            if (idx === activeIndex) {
              dot.classList.add('slider-counter__link--active');
            } else {
              dot.classList.remove('slider-counter__link--active');
            }
          });
        }

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (activeMedia.parentElement) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth'
            });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.elements.thumbnails.isVertical && this.elements.thumbnails.isVertical()) {
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop, behavior: 'smooth' });
        } else {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
